import { useEffect } from 'react';

/** Tab navigation gets a focus cue; pointer use and modifier keys do not. */
export function useKeyboardFocus() {
  useEffect(() => {
    const root = document.documentElement;
    const keyboard = (event: KeyboardEvent) => {
      if (event.key === 'Tab') root.dataset.keyboardFocus = 'true';
    };
    const pointer = () => { delete root.dataset.keyboardFocus; };
    document.addEventListener('keydown', keyboard, true);
    document.addEventListener('pointerdown', pointer, true);
    return () => {
      document.removeEventListener('keydown', keyboard, true);
      document.removeEventListener('pointerdown', pointer, true);
      delete root.dataset.keyboardFocus;
    };
  }, []);
}
